export default [
  {
    // 數據儀表(pages/Home)未開發完成,先隱藏:選單項目已拿掉,/admin 與 name 'home'(已登入開 / 或登入頁、logo)改導使用者管理。
    // 開發完成後還原 component/meta,並加回 TopNavBar、MobileMenuBar、Sidebar 的 navList。
    path: '/admin',
    name: 'home',
    redirect: { name: 'patientOverview', params: { id: 'init' } }
  },
  {
    path: '/admin/contest',
    name: 'contest-management',
    component: () => import('@/pages/Contest'),
    meta: {
      title: "量測管理",
      requireAuth: true,
      isSupportMobile: true
    }
  },
  {
    path: '/admin/appointment',
    name: 'appointment',
    component: () => import('@/pages/Appointment'),
    meta: {
      title: "預約管理",
      requireAuth: true,
      isSupportMobile: true
    }
  },
]
